import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'
import NoRecord from '../../components/elements/NoRecord'

export default function HolidayDashlet({ dropdowns, dropdownOptions }) {
  const [holidays, setHolidays] = useState([]);
  useEffect(() => {
    const holidayDropdownId = dropdowns.data.find((d) => d.code_key === 'holiday')?.id;
    if (holidayDropdownId && dropdownOptions) {
      const today = (new Date()).setHours(0, 0, 0, 0);
      setHolidays(
        dropdownOptions
        .filter((ddo) => ddo.dropdown_id === holidayDropdownId && (new Date(ddo.optional_value_1) >= today))
        .sort((a, b) => {
          return new Date(a.optional_value_1) - new Date(b.optional_value_1);
        }).slice(0, 3)
      )
    }
  }, []);
  return (
    <div className="message is-white lox-dashlet-detail">
      <div className="message-header has-background-primary has-text-white lox-dashlet-detail__title py-0">
        <p className="is-size-4">Upcoming Holidays</p>
      </div>
      <div className="message-body py-0 px-1">
        {holidays.length > 0 && (
          holidays.map((holiday) => {
            return (
              <div className="columns m-0" key={holiday.id}>
                <div className={`column ml-1 py-1 px-0`}>
                  <div className="lox-dashlet-detail__item py-0 px-1">
                <span className="lox-dashlet-detail__item__data has-text-dark has-text-weight-bold is-size-8 pl-2">
                  {/*TODO: replace format() with FormatISODate() once Sadequr updated that function*/}
                  {format(new Date(holiday.optional_value_1), 'MM/dd/yyyy')}
                </span>
                    <span
                      className="lox-dashlet-detail__item__data has-text-dark is-size-8 pl-2 ml-3"
                    >
                  {holiday.name}
                </span>
                  </div>
                </div>
              </div>
            )
          })
        )}
        {holidays.length === 0 && <NoRecord />}
      </div>
    </div>
  )
}
